import { MessageCircle, ShieldCheck, Users } from "lucide-react";

const FEATURES = [
  { icon: ShieldCheck, label: "Verified employers" },
  { icon: MessageCircle, label: "Genuine opportunities" },
  { icon: Users, label: "Better conversations" },
];

/** Left marketing panel for the ND1 sign-in page. */
export default function Nd1SigninMarketing() {
  return (
    <aside className="nd1-auth-aside nd1-auth-aside--signin" aria-label="Why sign in to JOBUWIN">
      <div className="nd1-auth-aside__copy">
        <h1 className="nd1-auth-aside__title">
          <span className="nd1-ink">Genuine jobs.</span>
          <span className="nd1-ink-green">Real people.</span>
        </h1>
        <p className="nd1-auth-aside__lede">
          JOBUWIN connects you with verified employers and genuine opportunities through real
          conversations.
        </p>
      </div>

      <figure className="nd1-auth-aside__art">
        <img
          src="/images/signin-illustration.png"
          alt="A hiring manager and job seeker having a genuine conversation, connected through JOBUWIN's verified platform."
          width={640}
          height={480}
          loading="lazy"
        />
      </figure>

      <ul className="nd1-auth-aside__features">
        {FEATURES.map(({ icon: Icon, label }) => (
          <li key={label}>
            <Icon className="nd1-icon" aria-hidden="true" />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
